import { useEffect, useState } from 'react';
import { storageClaimedPromo } from '../../utils/storage';
import { useAuth } from 'react-oidc-context';
import { ParsedPromo, PromoTypes } from '../../components/Layout/Promotions/types';
import { useUserContext } from '../../providers/UserProvider';
import { getAvailablegMxPromotions } from '../../components/Layout/Promotions/services';
import { compareWithPromoType, getMagicXCTA } from '../../components/Layout/Promotions/utils';

export const usePromoLoggedOut = (
  claimedPromo: ParsedPromo | null,
  showClaim: boolean
): { storedPromo: ParsedPromo | null } => {
  const { isAuthenticated } = useAuth();
  const { user } = useUserContext();

  const [storedPromo, setStoredPromo] = useState<ParsedPromo | null>(null);

  const getPlatormMagicXCTA = async (claimedPromoStorage: ParsedPromo): Promise<string | undefined> => {
    const receivedAvailableMXPromotions = compareWithPromoType(claimedPromoStorage?.promoType, PromoTypes.WAGER_AND_GET)
      ? await getAvailablegMxPromotions(user?.email)
      : [];

    const matchedPromo = receivedAvailableMXPromotions.find((promo) => promo?.slug === claimedPromoStorage.magicXSlug);
    const magicXCta = getMagicXCTA(matchedPromo);

    return magicXCta;
  };

  useEffect(() => {
    if (isAuthenticated && user?.email) {
      (async (): Promise<void> => {
        const claimedPromoStorage: ParsedPromo = JSON.parse(String(storageClaimedPromo.get()));

        if (claimedPromoStorage) {
          const magicXCta = await getPlatormMagicXCTA(claimedPromoStorage);
          const resultStoredPromo = { ...claimedPromoStorage, ...(magicXCta && { magicXCta }) };

          setStoredPromo(resultStoredPromo);
        }

        storageClaimedPromo.remove();
      })();
    }
  }, [isAuthenticated, user?.email]);

  useEffect(() => {
    showClaim && !isAuthenticated && storageClaimedPromo.set({ value: JSON.stringify(claimedPromo) });
  }, [showClaim]);

  return { storedPromo };
};
